export const SAVING_GOALS_BREADCRUMBS = [
  {
    children: 'Dashboard',
    href: `/dashboard`
  },
  {
    children: 'Saving goals'
  }
]
